import React from "react";
import { Modal, Card } from "antd";
import FormEvaluationAnswerGroupText from "../formEvaluationAnswerGroup/formEvaluationAnswerGroupText";

const ModalEvaluationAnswerGroup = ({
    visible,
    onClose,
    onSelect,
    dataEvaluationAnswerGroups = [],
}) => {
    return (
        <Modal
            title="Opciones de respuesta"
            open={visible}
            onCancel={onClose}
            footer={null}
            width="60%"
        >
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: 16,
                }}
            >
                {dataEvaluationAnswerGroups.map((eag, index) => (
                    <Card
                        key={eag.eag_id}
                        title={eag.eag_title}
                        bordered
                        hoverable
                        style={{ width: "40%" }}
                        onClick={() => onSelect(eag.eag_id)}
                    >
                        <FormEvaluationAnswerGroupText
                            index={index}
                            evaluationAnswerGroup={eag}
                            setIsEditing={null}
                            showEdit={false}
                        />
                    </Card>
                ))}
            </div>
        </Modal>
    );
};

export default ModalEvaluationAnswerGroup;
